import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          Hello, I’m Saroop Sathi Kesav (<span className="purple">SK</span>), a passionate technology professional with a strong academic and professional background, committed to driving innovation and operational excellence.
            <br />
            <br />
            <b>My Background</b>
            <br />
            <br />
            I was born and raised in the vibrant city of Delhi, India, where I developed an early love for learning and problem-solving. My higher secondary education was completed at Kendriya Vidyalaya, which laid the foundation for my academic achievements.
            <br />
            <br />
            <b>Educational Journey</b>
            <br />
            <br />
            I earned my Bachelor’s degree in Electronics from Kerala University, Trivandrum, graduating as a University 1st Rank Holder. My academic journey continued as I pursued and completed my Master’s degree in Software Engineering from the prestigious Birla Institute of Technology & Science (BITS), Pilani, Rajasthan, India.
            <br />
            <br />
            <b>Professional Path</b>
            <br />
            <br />
            In <b>2018</b>, I began my career at Wipro as a Project Engineer, where I gained invaluable experience and grew within the organization. Today, I hold the position of Technical Lead, developing, overseeing and contributing to complex technical projects with precision and dedication.
            <br />
            <br />
            In <b>March 2024</b>, I transitioned to Vancouver, Canada, to take on an exciting onsite role with Best Buy Canada as an DevOps Engineer. This move marked a significant milestone in my career, allowing me to apply my expertise on a global platform.
            <br />
            <br />
            <b>What I Stand For</b>
            <br />
            <br />
            I am driven by a passion for learning, innovation, and delivering impactful solutions. My journey reflects a blend of technical acumen, leadership, and a constant pursuit of excellence.
            <br />
            <br />
            Thank you for visiting my page and getting to know me better!

          </p>
          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Saroop</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
